import { CheckboxCSSStyleImpl } from '../../../../../../toolkit/checkbox/checkboxcss';
import { Colors } from '../../../../../../../utils/resources/colors';


export class CategoryCheckboxCSSStyleImpl extends CheckboxCSSStyleImpl
{
    getCSSStyleOne():Object
    {
        return {
            position: 'relative', 
            width: '18px', 
            height: '18px', 
            cursor: "pointer",
            backgroundColor: this.getResources().getColor(Colors.color_33), 
            borderRadius: '18px',
            border: "solid 1px" + this.getResources().getColor(Colors.color_5),
        };
    }
    getCSSStyleTwo():Object
    {
        return {
            position: 'absolute', height: '4px', 
            width: '8px', top: '5px', left: '4.5px', 
            borderLeft: 'solid 1px '+ this.getResources().getColor(Colors.color_5), 
            borderBottom: 'solid 1px '+ this.getResources().getColor(Colors.color_5), 
            borderRadius: '0px', 
            cursor: "pointer",
            transform: 'rotate(-45deg)'
        };
    }

    getCSSStyleThree():Object
    {
        return {
            position: 'relative', 
            width: '18px', 
            height: '18px', 
            borderRadius: '18px', 
            cursor: "pointer",
            backgroundColor: this.getResources().getColor(Colors.color_5),
            border: "solid 1px" + this.getResources().getColor(Colors.color_5)
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/createaccountcomponent/categorylist/viewmodel/categorycard/multiselectcategorycheckboxcss.ts